import React, { Fragment } from "react";
import {
  f7,
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Preloader,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Popover,
  TextEditor,
} from "framework7-react";

import {
  WalletSvg,
} from "../components/crumbs";

import Table from "../components/table";
import SheetPopup from "../components/sheetPopup";

import CreditCardInput from "react-credit-card-input";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { PaystackButton } from "react-paystack";
// check if staging or prod
import { PAYSTACK_PUBLIC_KEY } from "../config/envConfig";
import Cleave from "cleave.js/react";
import { firestoreConnect } from "../HOCs";
import { DocArray, Doc } from "../utils/_classes";
import {
  handleErrors,
  toast,
  generateId,
  isEmpty,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  initiateATransfer,
  sendOneTimePassword,
  verifyOneTimePassword,
  addOrRemoveBank,
  paystackTransactionCharge,
  transact,
  deleteCard,
  chargeCard,
} from "../utils/_helpers";

// moment
import moment from "moment";

// random bg color
const bgColors = ["bg-color-theme","bg-color-jasmine", "bg-color-oldlace","bg-color-pink","bg-color-bisque","bg-color-teagreen"]
const randomIndex = (maxLimit) => Math.floor(Math.random() * maxLimit);
class Profile extends React.Component {
  constructor(props) {
    super(props);
    var tab = props.f7route.params.id;

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
        orders: "",
      },
      orders: {},
      which: tab,

      // fund wallet
      amountToFund: 1000,

      // reference
      reference: generateId(15),

      // report merchant
      issue: "",
      reportIssueButton: "Submit Report",
      reportMerchant: {
        merchantName: "",
        merchantId: "",
        orderId: "",
      },

      confirmationCode: "",

      // Withdrawals
      withdrawalButton: "Confirm Transaction",
      withdrawalInfo: {
        recipientCode: "",
        amount: 1000,
      },

      // Bank
      addBankButton: "Upload Bank Details",
      bank: {
        bankName: "",
        accountName: "",
        accountNumber: "",
        sortCode: "",
        bankCode: "",
      },
      banks: [],
      BanksWithIssues: ["Parallex Bank"],

      // Add card
      addCardInputOpen: false,

      // Fund wallet sheet or popup
      sheetPopup: "sheet",
    };
  }

  render() {
    if (this.state.which == 1) {
      return (
        <Page id="profile-page" style={{ backgroundColor: "#fbfbfb" }}>
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Orders History </NavTitle>
          </Navbar>
          {this.props.loadingDoc && this.props.orders.length === 0 ? (
            <Block className="text-align-center">
              <Preloader></Preloader>
            </Block>
          ) : this.props.orders && this.props.orders.length === 0 ? (
            <>
              <Block className="pattern-banner bg-color-cornsilk">
                <Card style={{ width: "100%", margin: 0 }}>
                  <CardHeader>
                    <h3 style={{ margin: 0 }}>Purchases</h3>
                  </CardHeader>
                </Card>
              </Block>
              <div
                style={{
                  position: "relative",
                  width: "300px",
                  margin: "5vh auto",
                  textAlign: "center",
                  display: "block",
                }}
              >
                {/* <OrdersSvg size="300px" /> */}
                <img src="static/cart.gif" style={{ width: "300px" }} />
                <h4>Orders History Empty!</h4>
                <h6>Pss! What you waiting on?</h6>
                <Button fill round tabLink="#view-map">
                  Find restaurants near you!
                </Button>
              </div>
            </>
          ) : (
            [
              ...new Set(
                this.props.orders.map(
                  (order) => +moment(order.timestamp).format("YYYY"),
                ),
              ),
            ]
              .sort((a, b) => parseInt(b) - parseInt(a))
              .map((year) => (
                <React.Fragment key={year}>
                  
                  <Block className={`card pattern-banner ${bgColors[randomIndex(bgColors.length)]}`}>
                  <Card style={{ width: "100%", margin: 0 }}>
                      <CardHeader>
                        <h3 style={{ margin: 0 }}>Purchases in {year}</h3>
                      </CardHeader>
                    </Card>
                    </Block>
                  <div
                    className="timeline purchase-history"
                    style={{ marginBottom: "60px" }}
                  >
                    {[
                      ...new Set(
                        this.props.orders
                          .filter(
                            (order) =>
                              parseInt(
                                +moment(order.timestamp).format("YYYY"),
                              ) === parseInt(year),
                          )
                          .sort(
                            (a, b) =>
                              +moment(b.timestamp) - +moment(a.timestamp),
                          )
                          .map((order) => order.timestamp),
                      ),
                    ].map((timestamp) => (
                      <React.Fragment key={timestamp}>
                        <div className="timeline-item">
                          <div className="timeline-item-date">
                            {moment(timestamp).format("DD")}{" "}
                            <small>
                              {moment(timestamp).format("MMM").toUpperCase()}
                            </small>
                          </div>
                          <div className="timeline-item-divider"></div>
                          {[
                            ...new Set(
                              this.props.orders
                                .filter(
                                  (o) =>
                                    +moment(o.timestamp) === +moment(timestamp),
                                )
                                .map((o) => o.relId),
                            ),
                          ].map((relId) => (
                            <div
                              className="timeline-item-content card elevation-1"
                              style={{ marginBottom: "10pt" }}
                              key={relId}
                            >
                              <div className="card-header">
                                <span>
                                  {`${moment(timestamp).format(
                                    "dddd",
                                  )} at ${moment(timestamp).format(
                                    "HH:mm",
                                  )}hrs`}
                                </span>

                                {[
                                  this.props.orders
                                    .filter((o) => o.relId === relId)
                                    .map((o) => o.totalUserAmount)
                                    .reduce((a, b) => Number(a) + Number(b), 0),
                                ].map((totalAmount, i) => (
                                  <Button
                                    key={i}
                                    outline
                                    onClick={() => {
                                      this.setState({
                                        ...this.state,
                                        popupOpened: true,
                                        popupDataChanged: true,
                                        popupData: {
                                          title: "Order Details",
                                          which: "order",
                                          orders: this.props.orders.filter(
                                            (o) => o.relId === relId,
                                          ),
                                        },
                                      });
                                    }}
                                  >
                                    More
                                  </Button>
                                ))}
                              </div>
                              <div className="card-content">
                                <List>
                                  {this.props.orders
                                    .filter((o) => o.relId === relId)
                                    .map((o) =>
                                      o.packages.map((product) => (
                                        <ListItem key={randomIndex(10)+"_"+product.productId+"_"+randomIndex(100)}>
                                          <ListItemCell className="width-auto flex-shrink-0">
                                            <span
                                              style={{
                                                display: "inline-flex",
                                              }}
                                            >
                                              {product.count}{" "}
                                              &nbsp;x&nbsp;&nbsp;
                                            </span>
                                          </ListItemCell>
                                          <ListItemCell
                                            className="flex-shrink-3"
                                            style={{ marginLeft: 0 }}
                                          >
                                            <p>{product.name}</p>
                                          </ListItemCell>
                                          <ListItemCell className="width-auto flex-shrink-0">
                                            <small
                                              style={{
                                                fontSize: "10px",
                                                color: "gray",
                                              }}
                                            >
                                              {new Intl.NumberFormat("en-GB", {
                                                style: "currency",
                                                currency: "NGN",
                                              }).format(product.userAmount)}
                                            </small>
                                          </ListItemCell>
                                        </ListItem>
                                      )),
                                    )}
                                </List>
                              </div>
                            </div>
                          ))}
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </React.Fragment>
              ))
          )}

          <Popup
            swipeToClose="to-bottom"
            className="easychaw-popup"
            opened={this.state.popupOpened}
            onPopupClosed={() =>
              this.setState({
                ...this.state,
                popupOpened: false,
                popupDataChanged: false,
                popupData: { title: "", which: "", orders: "" },
              })
            }
            onPopupOpened={(e) => {
              e.app.methods.showFullText();

              this.state.popupData.orders.filter((order) => {
                const reviewedOrders =
                  (this.props.profile.ratings &&
                    this.props.profile.ratings[order.merchantId]) ||
                  [];
                //show dialog if order is completed and there is no review for this orderID in the user collection
                if (
                  order.orderStatus == "Order Completed" &&
                  reviewedOrders.indexOf(order.id) == -1
                )
                  this.rateMerchant(
                    order.id,
                    order.merchantName,
                    order.merchantId,
                  );
              });
            }}
          >
            <Page>
              <Navbar title={this.state.popupData.title}>
                <NavRight>
                  <Link popupClose>Close</Link>
                </NavRight>
              </Navbar>

              <Block className="pattern-banner bg-color-cultured">
                <Card style={{ width: "100%", margin: 0 }}>
                  <CardHeader>
                    <h3 style={{ margin: 0 }}>Purchase Order(s)</h3>
                  </CardHeader>
                </Card>
              </Block>

              {/* Content for viewing details of each order */}
              {this.state.popupData.which == "order" ? (
                <Block style={{ margin: "auto", marginBottom: "60px" }}>
                  {/* [Card - 1] Purchase Details */}
                  <Card style={{ margin: "auto", marginTop: "10pt" }}>
                    <CardHeader>
                      Purchase Details
                      <span>
                        {new Intl.NumberFormat("en-GB", {
                          style: "currency",
                          currency: "NGN",
                        }).format(
                          +this.state.popupData.orders
                            .map((o) => o.totalUserAmount)
                            .reduce((a, b) => +a + b, 0) +
                            +this.state.popupData.orders
                              .map((o) => o.userDeliveryCharge)
                              .reduce((a, b) => +a + b, 0) +
                            (+this.state.popupData.orders[0].serviceCharge ||
                              0),
                        )}
                      </span>
                    </CardHeader>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListItem
                          title={
                            this.state.popupData.orders
                              .map((o) => o.packages.length)
                              .reduce((a, b) => a + b, 0) + " Item(s)"
                          }
                        >
                          <small slot="after">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              +this.state.popupData.orders
                                .map((o) => o.totalUserAmount)
                                .reduce((a, b) => +a + b, 0),
                            )}
                          </small>
                          <Icon f7="creditcard" slot="media" />
                        </ListItem>

                        <ListItem
                          title={
                            this.state.popupData.orders
                              .map((o) => o.userDeliveryCharge)
                              .reduce((a, b) => +a + b, 0) !== 0
                              ? "Delivery Charge"
                              : "Pickup Charge"
                          }
                        >
                          <small slot="after">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              +this.state.popupData.orders
                                .map((o) => o.userDeliveryCharge)
                                .reduce((a, b) => +a + b, 0),
                            )}
                          </small>
                          <Icon f7="creditcard" slot="media" />
                        </ListItem>

                        <ListItem title="Service Charge">
                          <small slot="after">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              +this.state.popupData.orders[0].serviceCharge ||
                                0,
                            )}
                          </small>
                          <Icon f7="creditcard" slot="media" />
                        </ListItem>

                        <ListItem title="Date">
                          <small slot="after">
                            {moment(
                              this.state.popupData.orders[0].timestamp,
                            ).format("ddd, MMM Do YYYY, h:mm a")}
                          </small>
                          <Icon f7="creditcard" slot="media" />
                        </ListItem>

                        {this.state.popupData.orders[0].expectedDeliveryTime ? (
                         <ListItem
                         header="Expected Delivery Time"
                         title={moment(this.state.popupData.orders[0].expectedDeliveryTime).format("dddd, MMMM Do, YYYY | hh:mma")}
                         after="EDT"
                       >
                         <Icon f7="cube_box_fill" slot="media" />
                       </ListItem>
                      ) : null}
                      </List>
                    </CardContent>
                  </Card>

                  {this.state.popupData.orders
                    .sort((a, b) => +moment(a.timestamp) - +moment(b.timestamp))
                    .map((order) => (
                      <div key={order.id}>
                        <Card style={{ margin: "auto", marginTop: "10pt" }}>
                          <CardHeader>
                            {order.merchantName + ` (${order.packages.length})`}

                            <Button
                              outline
                              iconF7="doc_on_clipboard"
                              onClick={(e) =>
                                this.$f7.methods.copyText(e, "Order Id")
                              }
                            >
                              &nbsp;&nbsp;&nbsp;Order Id:
                              <span className="copytext">{order.id}</span>
                            </Button>
                          </CardHeader>
                          <CardContent>
                            <List>
                              <ListItem>
                                <ListItemCell
                                  className="flex-shrink-3"
                                  style={{ marginLeft: 0 }}
                                >
                                  <div className="row">
                                    <p className="col">Order Status</p>
                                  </div>
                                </ListItemCell>
                                <ListItemCell className="width-auto flex-shrink-0">
                                  <h6
                                    style={
                                      order.orderStatus === "Order Cancelled" ||
                                      ((order.reportMerchant || order.issue) &&
                                        order.orderStatus !== "Order Completed")
                                        ? { color: "red" }
                                        : order.orderStatus ===
                                          "Order Completed"
                                        ? { color: "green" }
                                        : { color: "teal" }
                                    }
                                  >
                                    {order.orderStatus === "Order Cancelled"
                                      ? "Declined"
                                      : order.orderStatus ===
                                        "Pending Confirmation"
                                      ? "Enroute"
                                      : (order.reportMerchant || order.issue) &&
                                        order.orderStatus !== "Order Completed"
                                      ? "Issue"
                                      : order.orderStatus}
                                  </h6>
                                  {order.orderStatus === "Order Completed" ? (
                                    order.confirmedByAdminOrSupport ? (
                                      <small>
                                        {moment(
                                          order.confirmedByAdminOrSupport
                                            .timestamp,
                                        ).format("ddd, MMM Do YYYY, h:mm a")}
                                      </small>
                                    ) : (
                                      <small>
                                        {order.confirmationTime
                                          ? moment(
                                              order.confirmationTime,
                                            ).format("ddd, MMM Do YYYY, h:mm a")
                                          : ""}
                                      </small>
                                    )
                                  ) : order.orderStatus ===
                                    "Order Cancelled" ? (
                                    order.cancelledByAdminOrSupport ? (
                                      <small>
                                        {moment(
                                          order.cancelledByAdminOrSupport
                                            .timestamp,
                                        ).format("ddd, MMM Do YYYY, h:mm a")}
                                      </small>
                                    ) : (
                                      <small>
                                        {order.cancelTimestamp
                                          ? moment(
                                              order.cancelTimestamp,
                                            ).format("ddd, MMM Do YYYY, h:mm a")
                                          : ""}
                                      </small>
                                    )
                                  ) : null}
                                </ListItemCell>
                              </ListItem>

                              {order.packages.map((product) => (
                                <ListItem key={product.productId}>
                                  <ListItemCell className="width-auto flex-shrink-0">
                                    <span style={{ display: "inline-flex" }}>
                                      {product.count} &nbsp;x&nbsp;&nbsp;
                                    </span>
                                  </ListItemCell>
                                  <ListItemCell
                                    className="flex-shrink-3"
                                    style={{ marginLeft: 0 }}
                                  >
                                    <div className="row">
                                      <p className="col">{product.name}</p>
                                    </div>
                                  </ListItemCell>
                                  <ListItemCell className="width-auto flex-shrink-0">
                                    <h6>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(product.userAmount)}
                                    </h6>
                                  </ListItemCell>
                                </ListItem>
                              ))}
                            </List>
                          </CardContent>
                          <CardFooter>
                            <Button
                              fill
                              className="button-fill-red"
                              disabled={
                                order.orderStatus == "Order Completed" ||
                                order.reportMerchant ||
                                order.orderStatus == "Order Cancelled"
                              }
                              onClick={() =>
                                this.reportMerchant(
                                  order.merchantName,
                                  order.merchantId,
                                  order.id,
                                )
                              }
                            >
                              Report Issue
                            </Button>

                            <Button
                              fill
                              popoverOpen=".easychaw-popover"
                              onClick={() =>
                                this.setState({
                                  confirmationCode: order.confirmationCode,
                                })
                              }
                            >
                              Confirmation Code
                            </Button>
                            <Button
                              outline
                              onClick={() =>
                                this.$f7.$(`#post-dated-${order.id}`).show()
                              }
                            >
                              More
                            </Button>
                          </CardFooter>
                        </Card>

                        {order.postDatedDate ? (
                          <Card
                            style={{
                              margin: "auto",
                              marginTop: "10pt",
                              display: "none",
                              animation: "glow 2s ease 0s 1",
                            }}
                            id={`post-dated-${order.id}`}
                          >
                            <CardHeader className="no-border">
                              Post Dated Details
                              <Button
                                outline
                                onClick={() => {
                                  this.$f7.$(`#post-dated-${order.id}`).hide();
                                }}
                              >
                                Hide
                              </Button>
                            </CardHeader>
                            <CardContent padding={false}>
                              <List>
                                <ListItem
                                  className="show-text"
                                  title={moment(order.postDatedDate).format(
                                    "dddd, MMMM Do, YYYY | hh:mm",
                                  )}
                                  after="Date | Time"
                                >
                                  <Icon f7="info_circle_fill" slot="media" />
                                </ListItem>

                                <ListItem
                                  className="show-text"
                                  title={order.postDatedInstructions}
                                  after="Instructions"
                                >
                                  <Icon f7="info_circle_fill" slot="media" />
                                </ListItem>
                              </List>
                            </CardContent>
                          </Card>
                        ) : (
                          <Card
                            style={{
                              margin: "auto",
                              marginTop: "10pt",
                              display: "none",
                              animation: "glow 2s ease 0s 1",
                            }}
                            id={`post-dated-${order.id}`}
                          >
                            <CardHeader className="no-border">
                              Post Dated Details
                              <Button
                                outline
                                onClick={() => {
                                  this.$f7.$(`#post-dated-${order.id}`).hide();
                                }}
                              >
                                Hide
                              </Button>
                            </CardHeader>
                            <CardContent padding={false}>
                              <Block className="block-info">
                                <Row>
                                  <Col>
                                    <p>No Post Dated Details</p>
                                  </Col>
                                </Row>
                              </Block>
                            </CardContent>
                          </Card>
                        )}
                      </div>
                    ))}

                  <Card
                    style={{
                      margin: "auto",
                      marginTop: "10pt",
                      display: "none",
                      animation: "glow 2s ease 0s 1",
                    }}
                    id="report-merchant"
                  >
                    <CardHeader className="no-border">
                      <span>
                        Report &nbsp; {this.state.reportMerchant.merchantName}
                      </span>
                      <Button
                        outline
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            issue: "",
                            reportMerchant: {
                              ...this.state.reportMerchant,
                              merchantId: "",
                              merchantName: "",
                              orderId: "",
                            },
                          });
                          this.$f7.$("#report-merchant").hide();
                        }}
                      >
                        Hide
                      </Button>
                    </CardHeader>
                    <CardContent padding={false}>
                      <TextEditor
                        placeholder="Enter text..."
                        onTextEditorChange={(value) =>
                          this.setState({
                            ...this.state,

                            issue: value,
                          })
                        }
                        buttons={[
                          ["bold", "italic", "underline", "strikeThrough"],
                          ["orderedList", "unorderedList"],
                        ]}
                      />
                    </CardContent>

                    <CardFooter>
                      <Button
                        round
                        fill
                        onClick={this.submitReport.bind(this)}
                        style={{ width: "100%" }}
                      >
                        {this.state.reportIssueButton === "Submit Report" ? (
                          this.state.reportIssueButton
                        ) : (
                          <Preloader></Preloader>
                        )}
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              ) : null}
            </Page>
          </Popup>

          <Popover
            className="easychaw-popover"
            onPopoverClose={() =>
              this.setState({
                confirmationCode: "",
              })
            }
          >
            <Block style={{ textAlign: "center" }}>
              <p>Give this code to delivery agent to claim package</p>
              <b>{this.state.confirmationCode}</b>
            </Block>
          </Popover>
        </Page>
      );
    }

    if (this.state.which == 2) {
      return (
        <Page
          id="profile-page"
          style={{ backgroundColor: "#efefef" }}
          onPageAfterIn={this.onPageAfterIn.bind(this)}
        >
          <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> Wallet </NavTitle>
          </Navbar>

          <Block>
            <Row>
              <Col width="100" medium="40">
                <div
                  style={{
                    width: "103%",
                    paddingTop: "9px",
                    marginLeft: "-6px",
                    position: "relative",
                  }}
                >
                  <WalletSvg id="usercard" title="Wallet" />
                  {this.props.wallets &&
                  this.props.wallets[this.props.userWalletId] ? (
                    <span className="walletBalance">
                      {new Intl.NumberFormat("en-GB", {
                        style: "currency",
                        currency: "NGN",
                      }).format(
                        this.props.wallets &&
                          this.props.wallets[this.props.userWalletId] &&
                          this.props.wallets[this.props.userWalletId].cash,
                      )}
                    </span>
                  ) : (
                    <span className="walletBalance">NGN 0.00</span>
                  )}
                  <em className="walletBalanceSubText">Wallet Balance</em>
                </div>

                {/* [Card-1]  Wallet Funding*/}
                <Card style={{ margin: "2pt auto auto" }} inner accordionList>
                  <AccordionItem>
                    <CardHeader>
                      Fund Wallet
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      <CardContent>
                        <List noHairlinesMd>
                          <ListItem title="Fee">
                            <small slot="after">
                              {`NGN ${Math.round(
                                paystackTransactionCharge(
                                  this.state.amountToFund,
                                ),
                              )}`}
                            </small>
                            <Icon f7="creditcard" slot="media" />
                          </ListItem>
                          <ListInput
                            label="Amount to deposit"
                            input={false}
                            info="Default validation"
                            style={{ paddingLeft: 0 }}
                          >
                            <Icon f7="creditcard_fill" slot="media" />

                            <Cleave
                              slot="input"
                              value={this.state.amountToFund}
                              options={{
                                numeral: true,
                                numeralThousandsGroupStyle: "thousand",
                              }}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  amountToFund: e.target.rawValue,
                                });
                              }}
                              placeholder="Minimum wallet funding is NGN 1,000"
                              required
                            />
                          </ListInput>
                        </List>
                      </CardContent>
                      <CardFooter className="easyPrintText">
                        <pre className="round">
                          <small>For payment use</small>
                        </pre>

                        <Button
                          className="button-fill-green"
                          disabled={
                            isNaN(parseInt(this.state.amountToFund)) ||
                            parseInt(this.state.amountToFund) < 1000
                          }
                          round
                          fill
                          onClick={() => {
                            if (parseInt(window.innerWidth) < 800) {
                              this.setState({
                                ...this.state,
                                sheetPopup: "sheet",
                              });
                              f7.sheet.open(".fund-wallet");
                            } else {
                              this.setState({
                                ...this.state,
                                sheetPopup: "popup",
                              });
                              f7.popup.open(".fund-wallet");
                            }
                          }}
                          style={{
                            width: "40%",
                            marginLeft: "10px",
                          }}
                        >
                          Next
                        </Button>
                      </CardFooter>
                    </AccordionContent>
                  </AccordionItem>
                </Card>

                {/* [Card-2]  Payment Details*/}
                <Card
                  style={{
                    width: "100%",
                    marginLeft: "0px",
                    margin: "15pt auto auto",
                  }}
                  inner
                  accordionList
                  className="data-table data-table-init"
                >
                  <AccordionItem>
                    <CardHeader>
                      <div className="data-table-title">Payment Cards</div>
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      {this.props.auth.isEmpty ||
                      this.props.profile.isEmpty ||
                      !this.props.profile.cards ||
                      this.props.profile.cards.length === 0 ? (
                        <CardContent padding={false}>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No payment details found</p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      ) : (
                        <CardContent padding={false}>
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  <span className="table-head-label">
                                    Institution
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Card Number
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Card Issuer
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Expires
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Action
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.profile.cards.map((card) => (
                                <tr key={card.signature}>
                                  <td className="label-cell">
                                    <img
                                      src={
                                        card.card_type === "mastercard"
                                          ? `static/${card.card_type.trim()}.svg`
                                          : false
                                          ? `static/${card.card_type.trim()}.png`
                                          : `static/${card.card_type.trim()}.png`
                                      }
                                      width="40"
                                    />
                                  </td>
                                  <td>
                                    <div>XXXX-XXXX-XXXX-{card.last4}</div>
                                  </td>
                                  <td>
                                    <div>{card.bank}</div>
                                  </td>
                                  <td>
                                    <div>
                                      {" "}
                                      {card.exp_month} / {card.exp_year}
                                    </div>
                                  </td>
                                  <td>
                                    <Button
                                      fill
                                      className="button-fill-red"
                                      onClick={() =>
                                        this.deleteAcard(
                                          card.authorization_code,
                                          card.signature,
                                        )
                                      }
                                      style={{
                                        maxWidth: "41px",
                                      }}
                                      iconF7="trash_circle"
                                    ></Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </CardContent>
                      )}

                      <CardFooter className="easyPrintText">
                        <pre
                          className="round"
                          style={{
                            minWidth: "40%",
                          }}
                        >
                          <small>For payment use</small>
                        </pre>

                        {!this.state.addCardInputOpen ? (
                          <Button
                            round
                            fill
                            style={{
                              minWidth: "40%",
                            }}
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                addCardInputOpen: true,
                              });
                            }}
                          >
                            Add Card
                          </Button>
                        ) : (
                          <Button
                            outline
                            round
                            style={{
                              minWidth: "40%",
                            }}
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                addCardInputOpen: false,
                              });
                            }}
                          >
                            Hide
                          </Button>
                        )}
                      </CardFooter>

                      {this.state.addCardInputOpen && (
                        <CardFooter>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>Add Payment Card &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <PaystackButton
                                  text="Continue"
                                  className="button button-fill-blue"
                                  onSuccess={this.addCardCallback.bind(this)}
                                  onClose={this.close.bind(this)}
                                  channels={["card"]}
                                  reference={this.reference()}
                                  email={
                                    !this.props.profile.isEmpty &&
                                    this.props.profile.email
                                  }
                                  metadata={{
                                    name:
                                      !this.props.profile.isEmpty &&
                                      this.props.profile.fullName,
                                    phone:
                                      !this.props.profile.isEmpty &&
                                      this.props.profile.phoneNumber,
                                    addCard: true,
                                    userId: this.props.auth.uid,
                                    transactionType: "Deposite",
                                    transaction: {
                                      doc: this.reference(),
                                      body: {
                                        walletId: this.props.profile.walletId,
                                        status: "Success",
                                        type: "Deposit",
                                        by: "User",
                                        name: this.props.profile.fullName,
                                        fee: Math.ceil(
                                          paystackTransactionCharge(100),
                                        ),
                                        amount: 100,
                                      },
                                    },
                                  }}
                                  amount={10000}
                                  publicKey={PAYSTACK_PUBLIC_KEY}
                                />
                              </Col>
                            </Row>

                            <Row className="bit">
                              <Col>
                                <p>
                                  To add a new card as payment method, your
                                  Easychaw wallet will be funded with the sum of
                                  NGN 100.
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        </CardFooter>
                      )}
                    </AccordionContent>
                  </AccordionItem>
                </Card>
              </Col>

              <Col width="100" medium="60">
                {/* [Card-3]  Bank Details*/}
                <Card
                  style={{
                    width: "100%",
                    marginLeft: "0px",
                    margin: "10pt auto auto",
                  }}
                  inner
                  accordionList
                  className="data-table data-table-init"
                >
                  <AccordionItem>
                    <CardHeader>
                      <div className="data-table-title">Bank Details</div>
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      {this.props.wallets &&
                      this.props.wallets[this.props.userWalletId] &&
                      this.props.wallets[this.props.userWalletId].bankDetails
                        .length === 0 ? (
                        <CardContent padding={false}>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No bank details found</p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      ) : (
                        <CardContent padding={false}>
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  <span className="table-head-label">Sno.</span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Institution
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Account Number
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Account Name
                                  </span>
                                </th>
                                <th>
                                  <span className="table-head-label">
                                    Action
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.wallets &&
                                this.props.wallets[this.props.userWalletId] &&
                                this.props.wallets[
                                  this.props.userWalletId
                                ].bankDetails.map(
                                  (
                                    {
                                      bankName,
                                      accountName,
                                      accountNumber,
                                      recipientCode,
                                    },
                                    i,
                                  ) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>
                                        <div>{bankName}</div>
                                      </td>
                                      <td>{accountNumber}</td>
                                      <td>
                                        <div>{accountName}</div>
                                      </td>
                                      <td>
                                        <Button
                                          fill
                                          onClick={() =>
                                            this.deleteBank(i, recipientCode)
                                          }
                                          style={{
                                            backgroundImage:
                                              "linear-gradient(#FF6969, #E02020)",
                                            color: "white",
                                            maxWidth: "41px",
                                          }}
                                          iconF7="trash_circle"
                                        ></Button>
                                      </td>
                                    </tr>
                                  ),
                                )}
                            </tbody>
                          </table>
                        </CardContent>
                      )}
                      <CardFooter className="easyPrintText">
                        <pre className="round">
                          <small>For withdrawal use</small>
                        </pre>
                        <Button
                          round
                          fill
                          style={{
                            width: "40%",
                            marginLeft: "10px",
                          }}
                          onClick={() => {
                            this.$f7.preloader.show();
                            fetchBanks((error, banks) => {
                              if (error) {
                                toast(this.$f7.toast, {
                                  text: "Something went wrong. Try again",
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                                return this.$f7.preloader.hide();
                              }
                              this.setState({
                                ...this.state,
                                banks,
                                popupOpened: true,
                                popupDataChanged: true,
                                popupData: {
                                  title: "Add Bank Details",
                                  which: "add-bank",
                                },
                              });
                              this.$f7.preloader.hide();
                            });
                          }}
                        >
                          Add Account
                        </Button>
                      </CardFooter>
                    </AccordionContent>
                  </AccordionItem>
                </Card>

                {/* [Card-4]  Withdrawal*/}
                {this.props.wallets &&
                this.props.wallets[this.props.userWalletId] ? (
                  this.props.wallets[this.props.userWalletId].ban ? (
                    <Card style={{ margin: "15pt auto" }} inner accordionList>
                      <AccordionItem>
                        <CardHeader>
                          Withdrawal
                          <AccordionToggle>
                            <Button
                              outline
                              iconF7="arrowtriangle_down_fill"
                            ></Button>
                          </AccordionToggle>
                        </CardHeader>

                        <AccordionContent>
                          <CardContent padding={false}>
                            <Block className="pab">
                              <Row>
                                <Col>
                                  <p>Access Revoked &nbsp;&nbsp;&nbsp;</p>
                                </Col>
                                <Col>
                                  <Link
                                    className="pal"
                                    tabLink="#view-message-master"
                                    onClick={() =>
                                      this.navMessage(
                                        "account",
                                        "admin",
                                        "account",
                                      )
                                    }
                                  >
                                    Contact Admin
                                  </Link>
                                </Col>
                              </Row>

                              <Row className="pat">
                                <Col>
                                  <p style={{ margin: "0", color: " #9E9E9E" }}>
                                    Suspicious activity detected on your
                                    account. Your acccount has been banned from
                                    making a withdrawal please contact admin.
                                  </p>
                                </Col>
                              </Row>
                            </Block>
                          </CardContent>
                        </AccordionContent>
                      </AccordionItem>
                    </Card>
                  ) : (
                    <Card
                      style={{ margin: "15pt auto auto" }}
                      inner
                      accordionList
                    >
                      <AccordionItem>
                        <CardHeader>
                          Withdrawal
                          <AccordionToggle>
                            <Button
                              outline
                              iconF7="arrowtriangle_down_fill"
                            ></Button>
                          </AccordionToggle>
                        </CardHeader>

                        <AccordionContent>
                          <CardContent>
                            <List noHairlinesMd>
                              {this.props.wallets[this.props.userWalletId]
                                .pendingWithdrawal &&
                              this.props.wallets[this.props.userWalletId]
                                .pendingWithdrawal.length > 0
                                ? this.props.wallets[
                                    this.props.userWalletId
                                  ].pendingWithdrawal.map((pw, i) => (
                                    <ListItem
                                      key={i}
                                      header="Pending Withdrawal"
                                      title={`#${pw.amount / 100}`}
                                      footer={
                                        pw.status ? "Processing" : "Failed"
                                      }
                                    >
                                      <Button
                                        round
                                        fill
                                        slot="after-title"
                                        disabled={pw.status}
                                        onClick={() => this.withdrawalRetry(pw)}
                                        className="button button-fill-blue"
                                        style={{
                                          minWidth: "20%",
                                        }}
                                      >
                                        Retry
                                      </Button>
                                    </ListItem>
                                  ))
                                : null}
                              <ListItem
                                title="Transfer charge"
                                after={`NGN100.00`}
                              >
                                <Icon f7="creditcard" slot="media" />
                              </ListItem>
                              <ListInput
                                label="Bank account"
                                type="select"
                                name="account"
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      recipientCode: e.target.value,
                                    },
                                  })
                                }
                                placeholder="Select account"
                                style={{ paddingLeft: 0 }}
                              >
                                <Icon f7="briefcase" slot="media" />
                                <option></option>
                                {this.props.wallets &&
                                  this.props.wallets[this.props.userWalletId] &&
                                  this.props.wallets[
                                    this.props.userWalletId
                                  ].bankDetails.map(
                                    (
                                      { accountName, bankName, recipientCode },
                                      i,
                                    ) => (
                                      <Fragment key={i}>
                                        <option value={recipientCode}>
                                          {accountName} - {bankName}
                                        </option>
                                      </Fragment>
                                    ),
                                  )}
                              </ListInput>

                              <ListInput
                                label="Amount to withdraw"
                                type="number"
                                name="withdrawal"
                                min="1000"
                                required
                                pattern="[0-9]"
                                validate
                                placeholder="Minimum withdrawal is NGN 1,000"
                                info={
                                  this.props.wallets &&
                                  this.props.wallets[this.props.userWalletId] &&
                                  `Available amount is ${new Intl.NumberFormat(
                                    "en-GB",
                                    {
                                      style: "currency",
                                      currency: "NGN",
                                    },
                                  ).format(
                                    this.props.wallets[this.props.userWalletId]
                                      .cash,
                                  )}`
                                }
                                value={this.state.withdrawalInfo.amount}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      amount: e.target.value,
                                    },
                                  })
                                }
                                style={{ paddingLeft: 0 }}
                              >
                                <Icon f7="creditcard_fill" slot="media" />
                              </ListInput>
                            </List>
                          </CardContent>
                          <CardFooter>
                            <Button
                              round
                              fill
                              disabled={
                                this.state.withdrawalInfo.amount < 1000
                                  ? true
                                  : this.state.withdrawalButton !==
                                    "Confirm Transaction"
                                  ? true
                                  : false
                              }
                              onClick={this.initiateTransfer.bind(this)}
                              className="button button-fill-blue"
                              style={{
                                width: "100%",
                              }}
                            >
                              {this.state.withdrawalButton ===
                              "Confirm Transaction" ? (
                                this.state.withdrawalButton
                              ) : (
                                <Preloader></Preloader>
                              )}
                            </Button>
                          </CardFooter>
                        </AccordionContent>
                      </AccordionItem>
                    </Card>
                  )
                ) : null}

                {/* [Card-5]  Wallet History*/}
                <Card style={{ margin: "15pt auto auto" }} inner accordionList>
                  <AccordionItem opened>
                    <CardHeader>
                      Wallet History
                      <AccordionToggle>
                        <Button
                          outline
                          iconF7="arrowtriangle_down_fill"
                        ></Button>
                      </AccordionToggle>
                    </CardHeader>

                    <AccordionContent>
                      <CardContent>
                        <List noHairlinesMd>
                          <ListItem title="Total transactions">
                            <small slot="after">
                              {this.props.transactions.length}
                            </small>
                            <Icon f7="number_square" slot="media" />
                          </ListItem>
                          <ListItem title="Total amount spent">
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                this.props.transactions
                                  .filter(
                                    (t) =>
                                      t.type === "Received" &&
                                      t.by === "Easychaw" &&
                                      !t.note,
                                  )
                                  .map((t) => t.amount)
                                  .reduce((a, b) => +a + +b, 0),
                              )}
                            </small>
                            <Icon f7="number_square" slot="media" />
                          </ListItem>
                          <ListItem title="Total amount withdrawn">
                            <small slot="after">
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(
                                this.props.transactions
                                  .filter((t) => t.type === "Withdrawn")
                                  .map((t) => t.amount)
                                  .reduce((a, b) => +a + +b, 0),
                              )}
                            </small>
                            <Icon f7="number_square" slot="media" />
                          </ListItem>
                          {this.props.loadingDoc && !this.props.wallets ? (
                            <Preloader></Preloader>
                          ) : (
                            <ListItem
                              title="Bonus Balance"
                              tooltip="Accumulated amount of bonuses given to you as a reward of patronage by Easychaw"
                            >
                              <small slot="after">
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.wallets &&
                                    this.props.wallets[
                                      this.props.userWalletId
                                    ] &&
                                    this.props.wallets[this.props.userWalletId]
                                      .bonuses,
                                )}
                              </small>
                              <Icon f7="gift" slot="media" />
                            </ListItem>
                          )}
                          {this.props.loadingDoc && !this.props.wallets ? (
                            <Preloader></Preloader>
                          ) : (
                            <ListItem
                              title="Wallet balance"
                              tooltip="This is the amount of money deposited into your Easychaw's wallet"
                            >
                              <small slot="after">
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.props.wallets &&
                                    this.props.wallets[
                                      this.props.userWalletId
                                    ] &&
                                    this.props.wallets[this.props.userWalletId]
                                      .cash,
                                )}
                              </small>
                              <Icon f7="number_square" slot="media" />
                            </ListItem>
                          )}
                        </List>
                      </CardContent>
                    </AccordionContent>
                  </AccordionItem>
                </Card>
              </Col>

              <Col width="100">
                {/* [Card-6]  Transactions Details*/}
                <Card
                  className="data-table data-table-init"
                  style={{
                    width: "100%",
                    margin: "15pt auto",
                    maxHeight: "700px",
                  }}
                >
                  <CardHeader>
                    <div className="data-table-title">Transactions</div>
                  </CardHeader>
                  {this.props.transactions.length === 0 ? (
                    <CardContent padding={false}>
                      <Block className="block-info">
                        <Row>
                          <Col>
                            <p>No transactions available at the moment</p>
                          </Col>
                        </Row>
                      </Block>
                    </CardContent>
                  ) : (
                    <CardContent
                      padding={false}
                      style={{ maxHeight: "600px", overflow: "scroll" }}
                    >
                      <table className="sticky">
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">
                                <Icon f7="doc_on_clipboard"></Icon> Copy
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">SNo.</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction ID
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction Amount
                              </span>
                            </th>

                            <th>
                              <span className="table-head-label">
                                Transaction Type
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Status</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction Time
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.transactions
                            .sort(
                              (a, b) =>
                                +moment(b.timestamp) - +moment(a.timestamp),
                            )
                            .map((transaction, i) => (
                              <tr key={transaction.id}>
                                <td
                                  onClick={(e) =>
                                    this.$f7.methods.copyText(
                                      e,
                                      "Transaction Code",
                                    )
                                  }
                                >
                                  <div>
                                    <Icon f7="doc_on_clipboard">
                                      <div className="copytext">
                                        {transaction.id}
                                      </div>
                                    </Icon>{" "}
                                    Copy
                                  </div>
                                </td>
                                <td>{i + 1} </td>
                                <td>{transaction.id}</td>
                                <td
                                  style={{
                                    color:
                                      transaction.type === "Deposit" ||
                                      (transaction.type === "Received" &&
                                        transaction.by !== "Easychaw")
                                        ? "green"
                                        : transaction.note
                                        ? "orange"
                                        : "red",
                                  }}
                                >
                                  {transaction.type === "Deposit"
                                    ? new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +transaction.amount - +transaction.fee,
                                      )
                                    : new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+transaction.amount)}
                                </td>
                                <td>
                                  {transaction.type === "Received" &&
                                  transaction.by === "Easychaw" &&
                                  !transaction.note
                                    ? `Purchase${
                                        transaction.from ? "(Wallet)" : ""
                                      }`
                                    : transaction.note
                                    ? "Admin Wallet"
                                    : transaction.type === "Received" &&
                                      transaction.by === "User"
                                    ? transaction.reason
                                    : transaction.type}
                                </td>
                                <td
                                  style={{
                                    color:
                                      transaction.status === "Success"
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  {transaction.status}
                                </td>
                                <td>
                                  <div>
                                    {moment(transaction.timestamp).fromNow()}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </CardContent>
                  )}
                </Card>
              </Col>
            </Row>
          </Block>

          <Popup
            swipeToClose="to-bottom"
            className="easychaw-popup"
            opened={this.state.popupOpened}
            onPopupClosed={() =>
              this.setState({
                ...this.state,
                popupOpened: false,
                popupDataChanged: false,
                popupData: { title: "", which: "", orders: "" },
              })
            }
          >
            <Page>
              <Navbar title="Editor">
                <NavRight>
                  <Link popupClose>Close</Link>
                </NavRight>
              </Navbar>

              <Block className="pattern-banner bg-color-jasmine">
                <Card style={{ width: "100%", margin: 0 }}>
                  <CardHeader>
                    <h3 style={{ margin: 0 }}>{this.state.popupData.title}</h3>
                  </CardHeader>
                </Card>
              </Block>

              {/* Content for add bank details */}
              {this.state.popupData.which == "add-bank" ? (
                <Block>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader>Account Details</CardHeader>
                    <CardContent>
                      <List noHairlinesMd form id="bank-editor">
                        <ListInput
                          label="Bank account name"
                          type="text"
                          info="Account name is automated"
                          disabled={true}
                          value={this.state.bank.accountName}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              bank: {
                                ...this.state.bank,
                                accountName: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon f7="briefcase" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Bank account number"
                          type="number"
                          placeholder="eg: 0123456789"
                          info="Bank account number is required"
                          required
                          validate
                          value={this.state.bank.accountNumber}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              bank: {
                                ...this.state.bank,
                                accountNumber: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon f7="creditcard_fill" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Bank name"
                          type="select"
                          name="bank"
                          style={{ paddingLeft: 0 }}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              bank: {
                                ...this.state.bank,
                                bankName: e.target.value,
                                bankCode: this.state.banks.find(
                                  (bank) => bank.name === e.target.value,
                                ).code,
                              },
                            })
                          }
                        >
                          <option></option>
                          {this.state.banks.map((bank) => (
                            <option key={bank.name} value={bank.name}>
                              {bank.name}
                            </option>
                          ))}

                          <Icon f7="building_2_fill" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Bank sort code"
                          type="text"
                          placeholder="Type sort code of account here"
                          info="Bank sort code is optional"
                          clearButton
                          value={this.state.bank.sortCode}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              bank: {
                                ...this.state.bank,
                                sortCode: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon f7="building_2_fill" slot="media" />
                        </ListInput>
                      </List>
                    </CardContent>
                    <CardFooter>
                      <small>&nbsp;</small>
                      <Button
                        round
                        fill
                        disabled={
                          this.state.addBankButton !== "Upload Bank Details"
                        }
                        style={{ width: "45%" }}
                        onClick={this.addBank.bind(this)}
                      >
                        {this.state.addBankButton} &nbsp;{" "}
                        {this.state.addBankButton !== "Upload Bank Details" && (
                          <Preloader></Preloader>
                        )}
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              ) : null}
            </Page>
          </Popup>

          {/* fund wallet sheet/popup */}
          <SheetPopup
            type={this.state.sheetPopup}
            title="Fund Wallet"
            className="fund-wallet"
          >
            <Block>
              <Table
                amount={new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "NGN",
                }).format(this.state.amountToFund)}
                fee={new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "NGN",
                }).format(
                  Math.ceil(paystackTransactionCharge(this.state.amountToFund)),
                )}
                topup={new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "NGN",
                }).format(
                  +this.state.amountToFund -
                    Math.ceil(
                      paystackTransactionCharge(this.state.amountToFund),
                    ),
                )}
              />
            </Block>
            <Block>
              <div className="padding-bottom">
                <PaystackButton
                  text="Fund my wallet"
                  className="button button-fill-green button-round"
                  onSuccess={this.callback.bind(this)}
                  onClose={this.close.bind(this)}
                  reference={this.state.reference}
                  email={
                    !this.props.profile.isEmpty && this.props.profile.email
                  }
                  metadata={{
                    name:
                      !this.props.profile.isEmpty &&
                      this.props.profile.fullName,
                    phone:
                      !this.props.profile.isEmpty &&
                      this.props.profile.phoneNumber,
                    transactionType: "Deposite",
                    transaction: {
                      doc: this.state.reference,
                      body: {
                        walletId: this.props.profile.walletId,
                        status: "Success",
                        type: "Deposit",
                        by: "User",
                        name: this.props.profile.fullName,
                        fee: Math.ceil(
                          paystackTransactionCharge(this.state.amountToFund),
                        ),
                        amount: +this.state.amountToFund,
                      },
                    },
                  }}
                  amount={+this.state.amountToFund * 100}
                  publicKey={PAYSTACK_PUBLIC_KEY}
                />
              </div>
              {!this.props.profile.isEmpty &&
                this.props.profile.cards &&
                this.props.profile.cards.length > 0 && (
                  <div className="margin-top">
                    <BlockTitle
                      style={{ color: "#000" }}
                      className="margin-buttom text-align-center"
                    >
                      Use Credit card
                    </BlockTitle>
                    <Block>
                      {this.props.profile.cards.map((card) => (
                        <Card key={card.signature}>
                          <Button
                            fill
                            className="button button-fill-blue"
                            onClick={() =>
                              this.fundWalletWithCard(
                                card.authorization_code,
                                card.email,
                              )
                            }
                          >
                            Fund wallet with {card.bank} {card.card_type}
                            ending with {card.last4}
                          </Button>
                        </Card>
                      ))}
                    </Block>
                  </div>
                )}
            </Block>
          </SheetPopup>
        </Page>
      );
    }
  }

  onPageAfterIn() {
    const self = this;
  }

  componentDidUpdate(prevProps) {
    // Auto update wallet name
    if (!prevProps.wallets && this.props.wallets) {
      if (
        !this.props.profile.isEmpty &&
        this.props.wallets &&
        this.props.wallets[this.props.profile.walletId] &&
        !this.props.wallets[this.props.profile.walletId].name
      ) {
        this.props.firestore
          .collection("wallets")
          .doc(this.props.profile.walletId)
          .update({ name: this.props.profile.fullName })
          .catch((error) => {});
      }
    }
  }

  rateMerchant(orderID, merchantName, merchantId) {
    const self = this;
    const app = self.$f7;
    app.dialog
      .create({
        title: "Rate Merchant",
        text: `Please rate <strong>${merchantName}</strong> service for completing order: <strong>${orderID}</strong>`,
        destroyOnClose: true,
        content: `
          <form id="review-form">
            <div class="emoticons">
              <div class="emoticons-wrapper">

                <label class="radio">
                  <input type="radio" name="emoji-radio" value="1"> 
                  <div class="emoji angry">
                    <figure class="face">
                      <span class="eyes">
                          <span class="eye"></span>
                          <span class="eye"></span>
                      </span>
                      <span class="mouth">
                      </span>
                    </figure>
                  </div>
                </label>

                <label class="radio">
                  <input type="radio" name="emoji-radio" value="2"> 
                  <div class="emoji sad">
                    <figure class="face">
                      <span class="eyes">
                        <span class="eye"></span>
                        <span class="eye"></span>
                      </span>
                      <span class="mouth tounge">
                      </span>
                    </figure>
                  </div>
                </label>

                <label class="radio">
                  <input type="radio" name="emoji-radio" value="3"> 
                  <div class="emoji speechless">
                    <figure class="face">
                      <span class="eyes">
                        <span class="eye"></span>
                        <span class="eye"></span>
                      </span>
                      <span class="mouth">
                      </span>
                    </figure>
                  </div>
                </label>

                <label class="radio">
                  <input type="radio" name="emoji-radio" value="4"> 
                  <div class="emoji smile">
                    <figure class="face">
                      <span class="eyes">
                        <span class="eye"></span>
                        <span class="eye"></span>
                      </span>
                      <span class="mouth">
                      </span>
                    </figure>
                  </div>
                </label>

                <label class="radio">
                  <input type="radio" name="emoji-radio" value="5" checked> 
                  <div class="emoji love">
                    <figure class="face">
                      <span class="eyes">
                        <span class="heart-eye">
                          <span class="heart"></span>
                        </span>
                        <span class="heart-eye">
                          <span class="heart"></span>
                        </span>
                      </span>
                      <span class="mouth tounge">
                      </span>
                    </figure>
                  </div>
                </label>
              </div>
            </div>

            <div 
              id="review_${orderID}" 
              class="text-editor"
              style="--f7-text-editor-height: 150px; margin: auto 0; width: 100%;">
              <div class="text-editor-content" contenteditable></div>
            </div>
          </form>
          `,
        on: {
          opened: function () {
            app.textEditor.create({
              el: `#review_${orderID}`,
              placeholder: "Enter text...",
              buttons: [["bold", "italic"]],
              mode: "keyboard-toolbar",
            });
          },
        },
        buttons: [
          {
            text: "Not Now",
            color: "gray",
            close: true,
          },
          {
            text: "Submit",
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              let reviewText = app.textEditor.get(`#review_${orderID}`).value;
              let reviewScore = parseInt(
                app.form.convertToData("#review-form")["emoji-radio"],
              );
              //TODO:
              // 1. secure clean up of reviewText
              if (reviewText.trim() === "") {
                switch (reviewScore) {
                  case 1:
                    reviewText = `I was angry with ${merchantName} service`;
                    break;
                  case 2:
                    reviewText = `I was sad with ${merchantName} service`;
                    break;
                  case 3:
                    reviewText = `I was okay with ${merchantName} service`;
                    break;
                  case 4:
                    reviewText = `I was happy with ${merchantName} service`;
                    break;
                  case 5:
                    reviewText = `I love ${merchantName} service`;
                    break;
                  default:
                    reviewText = `Speechless about ${merchantName} service`;
                    break;
                }
              }
              // 2. send rating to merchant collection and also update user collection
              // get merchant object
              this.props.firestore
                .collection("merchants")
                .doc(merchantId)
                .get()
                .then((snapshot) => {
                  if (!snapshot.exists) {
                    app.preloader.hide();
                    return toast(this.$f7.toast, {
                      text: "Merchant may have been deleted from our database, please contact admin",
                      position: "bottom",
                      horizontalPosition: "center",
                      closeButton: true,
                      cssClass: "custom-toast",
                      closeTimeout: 4000,
                    });
                  }

                  return snapshot.data().ratings ? snapshot.data().ratings : [];
                })
                .then((ratings) => {
                  return this.props.firestore
                    .collection("merchants")
                    .doc(merchantId)
                    .update({
                      ratings: [
                        ...ratings,
                        {
                          email: this.props.profile.email,
                          rating: reviewScore,
                          review: reviewText,
                          timestamp: Date.now(),
                          name: this.props.profile.fullName,
                        },
                      ],
                    });
                })
                .then(() => {
                  const userRatings = this.props.profile.ratings
                    ? this.props.profile.ratings
                    : {};

                  return this.props.firestore
                    .collection("users")
                    .doc(this.props.auth.uid)
                    .update({
                      ratings: userRatings[merchantId]
                        ? {
                            ...userRatings,
                            [merchantId]: [...userRatings[merchantId], orderID],
                          }
                        : { ...userRatings, [merchantId]: [orderID] },
                    });
                })
                .then(() => {
                  app.preloader.hide();
                  toast(this.$f7.toast, {
                    text: `Thank you for your review.`,
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  // 3. close the dialog on success
                  return dialog.close();
                })
                .catch((error) => {
                  app.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                });
            },
          },
        ],
      })
      .open();
  }

  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : "admin";
    const previousView = args[0] ? args[0] : "account";
    const previousPage = args[2] ? args[2] : "account";

    self.$f7.views["message-master"].router.navigate(
      {
        name: "message-master",
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      },
    );
  }

  fundWalletWithCard(authorizationCode, email) {
    this.$f7.preloader.show();
    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        const metadata = {
          name: !this.props.profile.isEmpty && this.props.profile.fullName,
          phone: !this.props.profile.isEmpty && this.props.profile.phoneNumber,
          transactionType: "Deposite",
          transaction: {
            doc: this.state.reference,
            body: {
              walletId: this.props.profile.walletId,
              status: "Success",
              type: "Deposit",
              by: "User",
              name: this.props.profile.fullName,
              fee: Math.ceil(
                paystackTransactionCharge(this.state.amountToFund),
              ),
              amount: +this.state.amountToFund,
            },
          },
        };

        const amount = +this.state.amountToFund * 100;

        chargeCard(
          idToken,
          this.props.auth.uid,
          authorizationCode,
          `${amount}`,
          email,
          this.state.reference,
          metadata,
          (error, message) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            this.$f7.preloader.hide();
            this.$f7.sheet.close();
            this.setState({
              ...this.state,
              reference: this.reference(),
            });
            return toast(this.$f7.toast, {
              text: `Your transaction has been ${message}. Your wallet will be funded as soon as your card is charged`,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  addCardCallback(response) {
    this.$f7.preloader.show();
    // if successfull send order to DB AND clear cart
    if (response.status === "success") {
      this.$f7.preloader.hide();
      this.$f7.sheet.close();
      this.setState({
        ...this.state,
        reference: this.reference(),
      });
      return toast(this.$f7.toast, {
        text: "Processing. As soon as your transaction is confirmed, your card will be added as a payment method.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } else {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: response.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  deleteAcard(authorizationCode, signature) {
    this.$f7.preloader.show();
    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        deleteCard(
          idToken,
          this.props.auth.uid,
          authorizationCode,
          signature,
          (error, response) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: response,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: error,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  callback(response) {
    this.$f7.preloader.show();
    // if successfull send order to DB AND clear cart
    if (response.status === "success") {
      this.$f7.preloader.hide();
      this.$f7.sheet.close();
      this.setState({
        ...this.state,
        reference: this.reference(),
      });
      return toast(this.$f7.toast, {
        text: "Your Easychaw wallet is been processed. Your funds will be available in your wallet shortly",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    } else {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: response.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  reference() {
    return generateId(15);
  }

  close() {}

  withdrawalRetry(pw) {
    this.$f7.preloader.show();
    // make transfer
    const transferDetails = {
      amount: pw.amount,
      recipient: pw.recipient,
      reason: {
        walletId: pw.reason.walletId,
        email: pw.reason.email,
        commission: pw.reason.commission,
      },
      retry: {
        reference: pw.reference,
      },
    };

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        transferDetails.token = idToken;
        transferDetails.uid = this.props.auth.uid;

        // initiate transfer
        initiateATransfer(transferDetails, (error, data) => {
          if (error) {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: error,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          }

          this.$f7.preloader.hide();
          return this.$f7.dialog.alert(
            "Processing transaction, you will recieve a mail shortly",
          );
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  initiateTransfer() {
    this.$f7.preloader.show();
    this.setState({
      ...this.state,
      withdrawalButton: "",
    });

    const cash = this.props.wallets[this.props.userWalletId].cash;
    const pendingWithdrawal = this.props.wallets[this.props.userWalletId]
      .pendingWithdrawal
      ? this.props.wallets[this.props.userWalletId].pendingWithdrawal
          .map((pw) => pw.amount / 100 + pw.reason.commission)
          .reduce((a, b) => a + b, 0)
      : 0;

    if (this.state.withdrawalInfo.recipientCode === "") {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Select a bank account",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (this.state.withdrawalInfo.amount < 1000) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Mininmum withdrawal is NGN1,000",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (+this.state.withdrawalInfo.amount + 100 > +cash - pendingWithdrawal) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        withdrawalButton: "Confirm Transaction",
      });
      return toast(this.$f7.toast, {
        text: "Insufficient Balance",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    const bankAccount = this.props.wallets[
      this.props.userWalletId
    ].bankDetails.find(
      ({ recipientCode }) =>
        recipientCode === this.state.withdrawalInfo.recipientCode,
    );

    this.$f7.preloader.hide();

    this.$f7.dialog.confirm(
      `
    <p><strong>Bank:</strong> ${bankAccount.bankName}</p>
    <p><strong>Account Name:</strong> ${bankAccount.accountName}</p>
    <p><strong>Account Number:</strong> ${bankAccount.accountNumber}</p>
    <p><strong>Amount:</strong> ${new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "NGN",
    }).format(+this.state.withdrawalInfo.amount)}</p>
    <p>You will be charged <strong>${new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "NGN",
    }).format(100)}</strong> for this transaction.</p>
    `,
      "Confirm Transaction",
      () => {
        // make transfer
        const transferDetails = {
          amount: `${+this.state.withdrawalInfo.amount * 100}`,
          recipient: this.state.withdrawalInfo.recipientCode,
          reason: {
            walletId: this.props.userWalletId,
            email: this.props.profile.email,
            commission: 100,
          },
        };
        this.$f7.preloader.show();

        this.props.firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            transferDetails.token = idToken;
            transferDetails.uid = this.props.auth.uid;

            // send OTP to merchant's email
            sendOneTimePassword(
              { type: "users", token: idToken, uid: this.props.auth.uid },
              (error, sent) => {
                if (error || !sent) {
                  this.setState({
                    ...this.state,
                    withdrawalButton: "Confirm Transaction",
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: error,
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }

                // open a dialog to confirm OTP
                this.$f7.preloader.hide();
                this.$f7.dialog
                  .create({
                    title: "OTP CODE",
                    cssClass: "otp-code-modal",
                    text: "Confirm withdrawal by filling in the OTP code sent to your email address",
                    content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                    buttons: [
                      // button to resend otp
                      {
                        text: "Resend Code",
                        color: "gray",
                        cssClass: "otp-resend",

                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          sendOneTimePassword(
                            {
                              type: "users",
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, sent) => {
                              if (error || !sent) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: "Confirm Transaction",
                                });

                                // if this error is a ban, close dialog
                                if (
                                  error ===
                                  "You cannot make a withdrawal at the moment. Please contact admin."
                                ) {
                                  dialog.close();
                                }
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: "OTP code sent",
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            },
                          );
                        },
                      },
                      // button to cancel
                      {
                        text: "x",
                        color: "white",
                        cssClass: "otp-close",
                        onClick: (dialog, e) => {
                          this.setState({
                            ...this.state,
                            withdrawalButton: "Confirm Transaction",
                          });
                          this.$f7.preloader.hide();
                        },
                      },
                      // button to continue
                      {
                        text: "Continue",
                        bold: true,
                        cssClass: "otp-continue",
                        keyCodes: [13],
                        close: false,
                        onClick: (dialog, e) => {
                          this.$f7.preloader.show();
                          // password
                          const password = dialog.$el
                            .find(".dialog-input")
                            .val();

                          // Verify otp
                          verifyOneTimePassword(
                            {
                              password,
                              type: "users",
                              token: idToken,
                              uid: this.props.auth.uid,
                            },
                            (error, success) => {
                              if (error || !success) {
                                this.setState({
                                  ...this.state,
                                  withdrawalButton: "Confirm Transaction",
                                });

                                // close if ban
                                if (
                                  error ===
                                  "You cannot make a withdrawal at the moment. Please contact admin."
                                ) {
                                  dialog.close();
                                }
                                this.$f7.preloader.hide();
                                return toast(this.$f7.toast, {
                                  text: error,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              }

                              // close dialog
                              dialog.close();

                              // initiate transfer
                              initiateATransfer(
                                transferDetails,
                                (error, data) => {
                                  if (error) {
                                    this.setState({
                                      ...this.state,
                                      withdrawalButton: "Confirm Transaction",
                                    });
                                    this.$f7.preloader.hide();
                                    return toast(this.$f7.toast, {
                                      text: error,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  }

                                  this.setState({
                                    ...this.state,
                                    withdrawalButton: "Confirm Transaction",
                                    withdrawalInfo: {
                                      ...this.state.withdrawalInfo,
                                      amount: 1000,
                                    },
                                  });
                                  this.$f7.preloader.hide();
                                  return this.$f7.dialog.alert(
                                    "Processing transaction, you will recieve a mail shortly",
                                  );
                                },
                              );
                            },
                          );
                        },
                      },
                    ],
                  })
                  .open();
              },
            );
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              withdrawalButton: "Confirm Transaction",
            });
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          });
      },
      () => {
        this.setState({
          ...this.state,
          withdrawalButton: "Confirm Transaction",
        });

        this.$f7.preloader.hide();
      },
    );
  }

  submitReport() {
    let text = {
      issueSent:
        "Issue sent. Easychaw's team will look into the issue and respond back to you.",
    };
    this.$f7.preloader.show();
    this.setState({
      ...this.state,
      reportIssueButton: "",
    });

    if (this.state.issue.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        reportIssueButton: "Submit Report",
      });

      return toast(this.$f7.toast, {
        text: "Whats your issue?",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    const reportMerchant = {
      issue: this.state.issue,
      timestamp: Date.now(),
    };

    this.props.firestore
      .collection("orders")
      .doc(this.state.reportMerchant.orderId)
      .update({ reportMerchant })
      .then(() => {
        toast(this.$f7.toast, {
          text: text.issueSent,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 10000,
        });
        this.setState({
          ...this.state,
          issue: "",
          reportIssueButton: "Submit Report",
          reportMerchant: {
            ...this.reportMerchant,
            merchantId: "",
            merchantName: "",
            orderId: "",
          },
        });
        this.$f7.preloader.hide();
        return this.$f7.$("#report-merchant").hide();
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          reportIssueButton: "Submit Report",
        });
        this.$f7.preloader.hide();

        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  reportMerchant(name, id, orderId) {
    this.$f7.$("#report-merchant").show();
    this.setState({
      ...this.state,
      reportMerchant: {
        merchantName: name,
        merchantId: id,
        orderId,
      },
    });
  }

  addBank() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addBankButton: "" });
    const bankDetails = {
      ...this.state.bank,
    };

    if (isEmpty(bankDetails.accountNumber)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "Account Number is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(bankDetails.bankName)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "Bank Name is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (this.state.BanksWithIssues.includes(bankDetails.bankName)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
      return toast(this.$f7.toast, {
        text: "We have issue with this bank's API, please choose another bank.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        resolveAccountNumber(
          bankDetails.accountNumber,
          bankDetails.bankCode,
          idToken,
          this.props.auth.uid,
          (error, data) => {
            this.$f7.preloader.hide();
            if (error) {
              this.setState({
                ...this.state,
                addBankButton: "Upload Bank Details",
              });
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            this.$f7.dialog.confirm(
              `Please confirm your account name: ${data.account_name}`,
              "Account Name",
              () => {
                this.setState({
                  ...this.state,
                  bank: {
                    ...this.state.bank,
                    accountName: data.account_name,
                  },
                });
                this.$f7.preloader.show();
                bankDetails.accountName = data.account_name;

                createTransferRecipient(
                  {
                    ...bankDetails,
                    token: idToken,
                    uid: this.props.auth.uid,
                    wallet: "user",
                  },
                  (error, recipientCode) => {
                    if (error) {
                      this.setState({
                        ...this.state,
                        addBankButton: "Upload Bank Details",
                      });
                      this.$f7.preloader.hide();
                      return toast(this.$f7.toast, {
                        text: "Something went wrong. Try again.",
                        position: "bottom",
                        horizontalPosition: "center",
                        closeButton: true,
                        cssClass: "custom-toast",
                        closeTimeout: 4000,
                      });
                    }

                    bankDetails.recipientCode = recipientCode;
                    if (this.props.profile.walletId) {
                      // update
                      const walletId = this.props.profile.walletId;
                      const update = [
                        ...this.props.wallets[walletId].bankDetails,
                        {
                          ...bankDetails,
                        },
                      ];

                      addOrRemoveBank(
                        walletId,
                        update,
                        idToken,
                        this.props.auth.uid,
                        (error, bankAdded) => {
                          if (error) {
                            this.setState({
                              ...this.state,
                              addBankButton: "Upload Bank Details",
                            });
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.setState({
                            ...this.state,
                            popupOpened: false,
                            addBankButton: "Upload Bank Details",
                            bank: {
                              ...this.state.bank,
                              bankName: "",
                              accountName: "",
                              accountNumber: "",
                              sortCode: "",
                              bankCode: "",
                            },
                          });
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "Bank Profile Uploaded",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    }
                  },
                );
              },
              () => {
                this.$f7.preloader.hide();
                this.setState({
                  ...this.state,
                  addBankButton: "Upload Bank Details",
                });
                this.$f7.preloader.hide();
              },
            );
          },
        );
      })
      .catch((error) => {
        this.setState({ ...this.state, addBankButton: "Upload Bank Details" });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  deleteBank(index, recipientCode) {
    this.$f7.preloader.show();
    const walletId = this.props.profile.walletId;
    const bankDetails = [...this.props.wallets[walletId].bankDetails];

    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        deleteTransferRecipient(
          {
            recipientCode,
            token: idToken,
            uid: this.props.auth.uid,
            wallet: "user",
          },
          (error, isDeleted) => {
            if (error) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: "Something went wrong. Cannot delete account, please try again",
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            bankDetails.splice(index, 1);

            addOrRemoveBank(
              walletId,
              bankDetails,
              idToken,
              this.props.auth.uid,
              (error, bankRemoved) => {
                if (error) {
                  this.$f7.preloader.hide();
                  toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }

                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: "Bank Profile Deleted",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              },
            );
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: {
    data,
    docs: { orders, loading, transactions, wallets },
  },
}) => ({
  auth,
  profile,
  data,
  orders: (orders && orders) || [],
  loadingDoc: loading,
  transactions: (transactions && transactions) || [],
  wallets: wallets || null,
});

const enhance = compose(
  firestoreConnect((props) => [
    new DocArray("orders", props.auth.uid, "userId"),
    new DocArray(
      "transactions",
      (props.auth && props.userWalletId) || null,
      "walletId",
    ),
    new Doc("wallets", (props.auth && props.userWalletId) || null),
  ]),
  connect(mapStateToProps),
);

export default enhance(Profile);
